<mat-toolbar class="card-box-title">
    <button mat-icon-button *ngIf="icon" class="title-icon">
        <i [ngClass]='icon'></i>
    </button>
    <span>{{title}} </span>
</mat-toolbar>
<div class="card-container">
    <ng-content></ng-content>
</div>